import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { DatePill, DatePillProps } from '../avatar-pill/date-pill';
import { ColumnHeaderWrapper } from '../column-header-wrapper';
import { SlotCount } from './slot-count';

interface Props extends DatePillProps {
  slotsCount?: number;
}

export const WeekdayColumnHeader = ({ slotsCount, ...props }: Props) => {
  return (
    <ColumnHeaderWrapper containerStyle={containerStyle}>
      <DatePill {...props} />
      {slotsCount !== undefined && <SlotCount count={slotsCount} />}
    </ColumnHeaderWrapper>
  );
};

const containerStyle = css({
  borderRight: `1px solid ${theme.colors.neutral10}`,
  '&:first-child': {
    borderLeft: `1px solid ${theme.colors.neutral10}`,
  },
  '> :first-child': {
    borderBottom: `1px solid ${theme.colors.neutral10}`,
    padding: theme.spacing(0.5),
  },
});
